import { useEffect, useState } from "react"
import { ShipApi } from "../Types"
import type { ILocalShip } from "../Types/Generated/LogbookApp/AppState"
import type { DataStore } from "./Store"

const requests = new WeakMap<DataStore, Promise<ILocalShip>>();

function companionRequest(store: DataStore): Promise<ILocalShip> {
  const existing = requests.get(store);
  if (existing) {
    return existing;
  }
  const request = new ShipApi(store.api()).ships.companion({ params: {} }).call();
  requests.set(store, request);
  request.catch(() => requests.delete(store));
  return request;
}

// Declarative companion discovery for store-backed views. The request lifecycle is owned
// here and deduplicated per app-scoped store; components only consume the resolved slice.
export function useCompanionShip(store: DataStore): ILocalShip | undefined {
  const [companion, setCompanion] = useState<ILocalShip>();
  useEffect(() => {
    let active = true;
    companionRequest(store)
      .then((value) => {
        if (active) setCompanion(value);
      })
      .catch(console.error);
    return () => {
      active = false;
    };
  }, [store]);
  return companion;
}
